var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyProfileBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 501,
    viewBox: "0 0 373 501",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4500_142452)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -319.77,
    width: 375,
    height: 820,
    fill: "#0099FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4500_142452",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -403,
    y: 34,
    width: 1199,
    height: 1159
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.48 1192.67L54.3132 1052.5L216.382 818.892C225.872 805.021 225.142 794.07 222.222 791.15C220.032 787.5 210.541 788.23 201.781 792.61L-22.3406 894.086C-56.6524 909.416 -97.5344 902.116 -123.816 875.835C-153.747 845.903 -159.588 799.181 -136.226 762.679L-54.4622 634.192C-46.4318 621.782 -46.4318 611.561 -50.082 607.911C-53.0021 604.991 -63.2227 603.531 -77.8234 613.751L-259.603 738.588L-402.69 595.5L383.56 54.5429C429.552 23.1513 474.815 31.9118 499.636 55.273C522.997 78.6341 534.678 122.436 505.476 169.159L386.48 356.778L674.845 227.562C712.807 210.041 753.689 217.341 777.05 245.083C801.871 275.744 801.141 318.816 774.13 357.508L194.48 1192.67Z",
    fill: "#0099FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4500_142452)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 263.506,
    cy: 591.039,
    r: 657.413,
    transform: "rotate(45 263.506 591.039)",
    fill: "#FFA300"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512.35,
    cy: 512.35,
    r: 512.35,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 -332.225 919.519)",
    fill: "url(#paint0_linear_4500_142452)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.658,
    cy: 487.658,
    r: 487.658,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 -888.886 558.366)",
    fill: "url(#paint1_linear_4500_142452)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4500_142452",
    x1: 365.929,
    y1: 526.879,
    x2: -110.242,
    y2: 396.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A49BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A49BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4500_142452",
    x1: 650.314,
    y1: 746.755,
    x2: 370.053,
    y2: 1290.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4500_142452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 802,
    fill: "white",
    transform: "translate(0 -301.77)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfileBackground);
export default __webpack_public_path__ + "static/media/my_profile_background.9f1a973763d5ec2900c64aa3a79bcb72.svg";
export { ForwardRef as ReactComponent };